import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutShare12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowOutShare12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.474 3.354a.5.5 0 0 1-.707 0L6.5 2.087v5.681a.5.5 0 0 1-1 0V2.085L4.231 3.354a.5.5 0 0 1-.707-.707L5.645.525 6 .172l.353.353 2.122 2.122a.5.5 0 0 1 0 .707M1 6.5A1.5 1.5 0 0 1 2.5 5h.875a.5.5 0 0 1 0 1H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-.875a.5.5 0 1 1 0-1H9.5A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutShare12);
